module.exports = __webpack_public_path__ + "assets/fonts/GothamProNarrow-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamProNarrow-Medium.woff
// module id = 1913
// module chunks = 0